<hive-inline-notification
    class="callout variant-{{ block().variant }}"
    [severity]="severity()"
    [heading]="block().title"
    [icon]="icon()"
>
    <!-- FR-048: plain text. Deliberately not <markdown> — a callout is one point, not a container. -->
    <p class="callout-body">{{ block().body }}</p>
    @if (actions().length) {
        <div class="callout-actions">
            @for (action of actions(); track $index) {
                <copilot-rich-block-action-button [action]="action" (activate)="activateAction.emit($event)" />
            }
        </div>
    }
</hive-inline-notification>
